import type { McpTokenStatus } from 'api';

import { Badge } from '@atoms/badges/Badge/Badge';

import { MCP_STATUS_LABELS } from './constants';

const STATUS_CLASSES: Record<McpTokenStatus, string> = {
  active: 'bg-status-completed',
  revoked: 'bg-status-neutral',
  expired: 'bg-status-action-required'
};

type McpTokenStatusBadgeProps = {
  status: McpTokenStatus;
  'data-testid'?: string;
};

export const McpTokenStatusBadge = ({
  status,
  'data-testid': dataTestId
}: McpTokenStatusBadgeProps) => (
  <Badge
    label={MCP_STATUS_LABELS[status]}
    className={STATUS_CLASSES[status]}
    data-testid={dataTestId}
  />
);
